<template>
  <div class="home-page">
    <LandingHero /><LandingSolutions /><LandingSystem /><LandingPackages />
    <section class="catalog-callout">
      <div class="shell">
        <div>
          <span class="eyebrow light-eyebrow">СОБЕРИТЕ СВОЮ СИСТЕМУ</span>
          <h2>Правильное оборудование<br />Для вашей задачи</h2>
          <p>Камеры, сетевое оборудование и всё необходимое для видеонаблюдения.</p>
        </div>
        <NuxtLink to="/products" class="button button-dark">Перейти в каталог</NuxtLink>
      </div>
    </section>
    <LandingInstallation /><LandingEstimate /><LandingFaq /><LandingClosing />
  </div>
</template>
<script setup lang="ts">
useSeoMeta({
  title: 'Robotics Vision — спокойствие в вашем поле зрения',
  description:
    'Продажа и установка видеонаблюдения в Санкт-Петербурге. Камеры, монтаж, локальный архив и собственная система Robotics Vision.',
});
</script>
